import { render, staticRenderFns } from "./CompetitionCard.vue?vue&type=template&id=34e74bc3&scoped=true&"
import script from "./CompetitionCard.vue?vue&type=script&lang=js&"
export * from "./CompetitionCard.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionCard.vue?vue&type=style&index=0&id=34e74bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e74bc3",
  null
  
)

export default component.exports